import { render, staticRenderFns } from "./editSort.vue?vue&type=template&id=6ea10a73"
import script from "./editSort.vue?vue&type=script&lang=js"
export * from "./editSort.vue?vue&type=script&lang=js"
import style0 from "./editSort.vue?vue&type=style&index=0&id=6ea10a73&prod&lang=less&sconped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports